import privateAxios from "./axiosPrivate";
import { marketingIdentifiersURL } from "./constants/apiEndPoints";
import {
  buildMarketingIdentifiers,
  clearStoredAdClickIds
} from "./marketingIdentifiers";

/**
 * Sends the browser's Google and Meta identifiers to the signed-in customer's account so a
 * server-side conversion can be attributed to them.
 *
 * Signup carries them in its own payload; this covers everyone who already has an account,
 * whose identifiers would otherwise never be recorded. The backend reads the account from the
 * token, so nothing identifying is passed here. Failures are swallowed: attribution is never
 * worth interrupting a login for, and the next login retries.
 */
const recordMarketingIdentifiers = async () => {
  const identifiers = buildMarketingIdentifiers();
  if (Object.keys(identifiers).length === 0) return;

  try {
    await privateAxios.put(marketingIdentifiersURL, identifiers);
    // This account owns the click once it is stored. Leaving it in the browser would credit
    // it to the next person to sign in here as well.
    clearStoredAdClickIds();
  } catch {
    // ignore — the next login retries
  }
};

export default recordMarketingIdentifiers;
